<template>
  <div>
    <click-to-edit
      v-if="value.scale_type === $cascadingConstants.scales.types.TYPE_QUANTITY"
      v-model="value.fact"
      digits-only
      placeholder=""
      @input="changedQuantity"
    ></click-to-edit>

    <click-to-edit
      v-if="value.scale_type === $cascadingConstants.scales.types.TYPE_QUALITY"
      v-model="value.scale.fact_scope_id"
      type="select"
      placeholder=""
      select-filterable
      :select-options="scopes"
      select-option-id="id"
      select-option-name="name"
      select-cast-value-to-int
      @input="changed"
    >
    </click-to-edit>
  </div>
</template>

<script>


import {paginator} from "@/mixins/paginator";
import ClickToEdit from "@/components/ClickToEdit.vue";

export default {
  name: "CascadingScaleFactInput",
  components: {ClickToEdit},
  props: {
    value: {}, // whole element
  },
  computed: {
    scopes() {
      if( this.value?.scale?.template_id ) {
        return this.value.scale?.template?.scopes || [];
      }
      return this.value?.scale?.scopes || [];
    },
  },
  data() {
    return {
      loading: false,
      query: null,
      page: 1,
      options: [],
    }
  },
  mounted() {},
  methods: {


    changedQuantity() {
      this.value.scale.fact = this.value.fact;
      this.changed();
    },
    changed() {
      this.$emit('input', this.value);
      this.$emit('change', this.value);
    }
  },

}
</script>


<style scoped>

</style>